var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('CRUDTable',{attrs:{"title":_vm.title,"headers":_vm.headers,"items":_vm.workers,"userRole":_vm.userRole,"sort-by":"username","item-key":"id"},on:{"setWorkload":function($event){return _vm.setWorkload($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }